import React, { useState } from 'react';
import { CourierReportListTable } from 'components/OrderListTable/CourierReportListTable';
import { Loader } from 'components/Loader/Loader';
import { CalendarFetch } from 'components/OrderListTable/CalendarFetch/CalendarFetch';
import { ReqEnum } from 'const/requestStatus';
import dayjs from 'dayjs';
import { Region } from 'types/orderTypes';
import { Helmet } from 'react-helmet';
import { useFetchDeliveries } from '../../hooks/useFetchDeliveries';

export function CourierReportComposition({
  region,
}: {
  region?: Region;
}): JSX.Element {
  const [startDate, setStartDate] = useState(dayjs(new Date()));
  const [endDate, setEndDate] = useState(dayjs(new Date()));

  const fetchValues = values => {
    const { startDate, endDate } = values;
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const [deliveries, fetchStatus] = useFetchDeliveries(
    startDate,
    endDate,
    region
  );

  return (
    <div>
      <Helmet>
        <title>Reports - Courier</title>
      </Helmet>
      <CalendarFetch fetchValues={fetchValues} allowedStatuses={[]} />
      {fetchStatus === ReqEnum.PENDING && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Loader type="spinner" size="large" />
        </div>
      )}
      <CourierReportListTable
        deliveries={deliveries ? deliveries : []}
        fetchStatus={fetchStatus}
      />
    </div>
  );
}
